import React from 'react'
import Account from 'src/app/Account/Account'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AccountBudgetHistoryAppRoute from 'src/navigation/appRoutes/account/accountBudgetHistory.appRoute'
import AccountBudgetsAppRoute from 'src/navigation/appRoutes/account/accountBudgets.appRoute'
import AccountOverviewAppRoute from 'src/navigation/appRoutes/account/accountOverview.appRoute'
import AccountSettingsAppRoute from 'src/navigation/appRoutes/account/accountSettings.appRoute'
import AccountTransactionsAppRoute from 'src/navigation/appRoutes/account/accountTransactions.appRoute'
import AccountVirtualCardsAppRoute from 'src/navigation/appRoutes/account/accountVirtualCards.appRoute'
import AccountsAccountsAppRoute from 'src/navigation/appRoutes/accounts/accountsAccounts.appRoute'
import AccountsBudgetsAppRoute from 'src/navigation/appRoutes/accounts/accountsBudgets.appRoute'
import AccountsRequestsAppRoute from 'src/navigation/appRoutes/accounts/accountsRequests.appRoute'
import AccountsVirtualCardsAppRoute from 'src/navigation/appRoutes/accounts/accountsVirtualCards.appRoute'
import { accountRouteProps } from 'src/navigation/routeProps'

const AccountAppRoute: AppRoute = {
  id: AppLocation.Account,
  routeProps: accountRouteProps,
  component: <Account />,
  subRoutes: [
    AccountOverviewAppRoute,
    AccountBudgetsAppRoute,
    AccountVirtualCardsAppRoute,
    AccountTransactionsAppRoute,
    AccountBudgetHistoryAppRoute,
    AccountSettingsAppRoute,
  ],
  exceptions: [
    AccountsAccountsAppRoute,
    AccountsBudgetsAppRoute,
    AccountsVirtualCardsAppRoute,
    AccountsRequestsAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountAppRoute
